import OktaAuth from "@okta/okta-auth-js";
import { axiosApi, maycaApi } from "../helpers/api_helper";
import {
  AUTH_MAYCA_KEY,
  AUTH_USER_KEY,
  ROLE_MAYCA,
  TOKEN_KEY,
  TOKEN_MAYCA_KEY,
} from "../routes/constants";
import oktaCofig from "../oktaConfig";
import { error as showError } from "toastr";

export class LoginRepository {
  endpoint = "/auth";
  oktaAuth = new OktaAuth(oktaCofig.oidc);

  async loginWithOkta() {
    try {
      await this.oktaAuth.token.getWithRedirect({
        responseType: "token id_token",
        scopes: oktaCofig.oidc.scopes,
      });
    } catch (error) {
      throw new Error("Error en el inicio de sesión: " + error.message);
    }
  }

  async getOktaInfo() {
    try {
      // Intenta obtener el token desde el tokenManager
      const accessToken = await this.oktaAuth.tokenManager.get("accessToken");
      if (!accessToken) {
        const tokenResponse = await this.oktaAuth.token.getWithoutPrompt({
          responseType: "token id_token",
          scopes: oktaCofig.oidc.scopes,
        });

        // Almacena el token en el tokenManager
        this.oktaAuth.tokenManager.setTokens(tokenResponse.tokens);
      }

      const userInfo = await this.oktaAuth.getUser();
      return { userToken: accessToken?.accessToken, userInfo };
    } catch (err) {
      throw new Error(`Error obteniendo información de Okta: ${err.message}`);
    }
  }

  async loginWithOktaAndSetData() {
    try {
      await this.oktaAuth.handleRedirectCallback();
      const { userToken, userInfo } = await this.getOktaInfo();

      this.setToken(userToken);
      this.setMaycaToken(userToken);

      this.setUser(userInfo);

    } catch (err) {
      showError(`Error al iniciar sesión con Okta: ${err.message}`);
      throw err;
    }
  }

  async validateToken() {
    try {
      const token = await this.oktaAuth.tokenManager.get("accessToken");
      const response = await maycaApi.post(
        oktaCofig.oidc.introspectionEndpoint,
        new URLSearchParams({
          token: token.accessToken,
          token_type_hint: "access_token",
          client_id: oktaCofig.oidc.clientId,
          client_secret: oktaCofig.oidc.clientSecret,
        }),
        {
          headers: { "Content-Type": "application/x-www-form-urlencoded" },
        }
      );
      return response.data.active; // true si el token es válido
    } catch (error) {
      console.error("Error validando el token:", error);
      return false;
    }
  }

  //Obtener esta de autenticación actual
  async getOktaAuthState() {
    try {
      return await this.oktaAuth.authStateManager.getAuthState();
    } catch (err) {
      console.error("Error obteniendo el estado de autenticación:", err);
      throw err;
    }
  }

  async logoutOkta() {
    try {
      const idToken = await this.oktaAuth.tokenManager.get("idToken");

      if (!idToken) {
        console.error(
          "No se encontró el idToken. El usuario no está autenticado."
        );
        return;
      }
      const logoutUrl = `${process.env.REACT_APP_OKTA_LOGOUT_ENDPOINT}?id_token_hint=${idToken.idToken}&post_logout_redirect_uri=${window.location.origin}`;

      this.logout();

      window.location.href = logoutUrl;
    } catch (error) {
      console.error("Error durante el cierre de sesión:", error);
    }
  }

  async register(payload) {
    const response = await axiosApi.post(`${this.endpoint}/register`, payload);
    const data = response.data;
    if (response.status === 201) {
      this.setUser(data.user_data);
      this.setToken(data.token);
      return response.data;
    }

    throw new Error(response.response.data.message);
  }

  logout() {
    localStorage.clear();
    sessionStorage.clear();
    //window.location.replace("/");
  }

  setData(key, data) {
    localStorage.setItem(key, JSON.stringify(data));
  }

  getData(key) {
    let data = localStorage.getItem(key);
    if (data) {
      return JSON.parse(data);
    }
  }

  getInfoUser() {
    return this.getData(AUTH_USER_KEY);
  }

  setUser(data) {
    this.setData(AUTH_USER_KEY, data);
  }

  setMaycaUser(data) {
    this.setData(AUTH_MAYCA_KEY, data);
  }

  getToken() {
    return localStorage.getItem(TOKEN_KEY);
  }

  getMaycaTOken() {
    return localStorage.getItem(TOKEN_MAYCA_KEY);
  }

  getMaycaRole() {
    return localStorage.getItem(ROLE_MAYCA);
  }

  setToken(data) {
    localStorage.setItem(TOKEN_KEY, data);
  }

  setMaycaToken(data) {
    localStorage.setItem(TOKEN_MAYCA_KEY, data);
  }
  setMaycaRole(data) {
    localStorage.setItem(ROLE_MAYCA, data);
  }

  logOut() {
    localStorage.removeItem(AUTH_MAYCA_KEY);
    localStorage.removeItem(TOKEN_MAYCA_KEY);
    localStorage.removeItem(ROLE_MAYCA);
  }
}

export default LoginRepository;
